export interface GameStatisticsSlice {
  totalQuestions?: number;
  questionsAnswered?: number;
  averageScore?: number;
}

export interface SavedGameForStats {
  statistics: GameStatisticsSlice;
  leaderboard: Array<{ score: number }>;
}

/** Questions actually played in one saved game (prefers questionsAnswered over deck size). */
export function questionsPlayedFromGameStats(stats: GameStatisticsSlice): number {
  if (typeof stats.questionsAnswered === 'number' && stats.questionsAnswered >= 0) {
    return stats.questionsAnswered;
  }
  return stats.totalQuestions ?? 0;
}

/** Party drink games store drinks in leaderboard.score / hotTakesStats. */
export function isDrinkBasedGame(gameType: string | undefined | null): boolean {
  return gameType === 'hot-takes' || gameType === 'would-you-rather';
}

export function scoreUnitLabel(gameType: string | undefined | null, session = false): string {
  if (isDrinkBasedGame(gameType)) {
    return session ? 'drinks (session)' : 'drinks';
  }
  return session ? 'pts (session)' : 'pts';
}

export function aggregateSavedGameStats(games: SavedGameForStats[]): {
  gamesPlayed: number;
  questionsPlayed: number;
  totalPoints: number;
  averageScore: number | null;
} {
  if (games.length === 0) {
    return { gamesPlayed: 0, questionsPlayed: 0, totalPoints: 0, averageScore: null };
  }

  const questionsPlayed = games.reduce(
    (sum, game) => sum + questionsPlayedFromGameStats(game.statistics),
    0
  );
  const totalPoints = games.reduce(
    (sum, game) =>
      sum + game.leaderboard.reduce((gameSum, entry) => gameSum + entry.score, 0),
    0
  );
  const averageScore = Math.round(
    games.reduce((sum, game) => sum + (game.statistics.averageScore || 0), 0) / games.length
  );

  return {
    gamesPlayed: games.length,
    questionsPlayed,
    totalPoints,
    averageScore,
  };
}
